import { useDidMountEffect } from "hooks/useDidMountEffect";
import React, { useState } from "react";
import { ContainerCounter, InputCounter, OperationButton } from "../shared/MainStyles";
import { isNormalInteger } from "./utils";

interface IVehicleCounter {
  countValue: number;
  onChangeCountValue: (value: number) => void;
}
export default function VehicleCounter({ countValue, onChangeCountValue }: IVehicleCounter) {
  const [defaultValue, setDefaultValue] = useState<string>(countValue.toString());
  const onChangeValue = (value: number) => {
    const newValue = countValue + value;
    newValue >= 1 && onChangeCountValue(newValue);
  };

  useDidMountEffect(() => {
    setDefaultValue(countValue.toString());
  }, [countValue]);

  const handleChangeInput = (value: string) => {
    if (value.length) {
      if (/^\d+$/.test(value) && Number(value) > 0) {
        onChangeCountValue(Number(value));
        setDefaultValue(value);
      }
    } else {
      setDefaultValue("");
    }
  };

  const onLeaveInput = () => {
    if (isNormalInteger(defaultValue) && Number(defaultValue) > 0) {
      setDefaultValue(countValue.toString());
      onChangeCountValue(countValue);
    } else {
      setDefaultValue(countValue.toString());
    }
  };

  return (
    <ContainerCounter>
      <OperationButton
        aria-disabled={countValue <= 1}
        onClick={(e) => {
          e.preventDefault();
          onChangeValue(-1);
        }}
      >
        -
      </OperationButton>
      <InputCounter
        value={defaultValue}
        onChange={(e) => handleChangeInput(e.target.value)}
        onBlur={(e) => onLeaveInput()}
      />
      <OperationButton
        onClick={(e) => {
          e.preventDefault();
          onChangeValue(1);
        }}
      >
        +
      </OperationButton>
    </ContainerCounter>
  );
}
